import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        fill="none"
        viewBox="0 0 24 24"
        ref={ref}
        {...props}
    >
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M2.928 7.628a4.7 4.7 0 0 1 4.7-4.7h8.744a4.7 4.7 0 0 1 4.7 4.7v8.744a4.7 4.7 0 0 1-4.7 4.7H7.628a4.7 4.7 0 0 1-4.7-4.7zm1.44-.514h15.264a3.3 3.3 0 0 0-3.26-2.786H7.628a3.3 3.3 0 0 0-3.26 2.786m15.304 1.4H4.328v7.858a3.3 3.3 0 0 0 3.3 3.3h8.744a3.3 3.3 0 0 0 3.3-3.3z"
            clipRule="evenodd"
        />
        <path
            fill="currentColor"
            d="M8.974 16.035a1.009 1.009 0 1 1-2.017 0 1.009 1.009 0 0 1 2.017 0m4.035 0a1.009 1.009 0 1 1-2.018 0 1.009 1.009 0 0 1 2.018 0m0-4.035a1.009 1.009 0 1 1-2.018 0 1.009 1.009 0 0 1 2.018 0m4.034 0a1.009 1.009 0 1 1-2.017 0 1.009 1.009 0 0 1 2.017 0"
        />
    </svg>
);
const ForwardRef = forwardRef(SvgComponent);
export default ForwardRef;
